import { EditorPlugins } from '@acheloisbiosoftware/absui.core';

export const serializer = (editor, value) => {
  if (!editor.hasContent()) return null;
  return { webComponents: value, plainText: EditorPlugins.BaseEditor.string(editor, []) };
};

export const deserializer = (value) => value?.webComponents ?? [];
